import React from 'react';
import { Link } from 'react-router-dom';
import SocialLinksRow from '@/components/SocialLinksRow';

const FOOTER_LINKS = [
  { label: 'Privacy policy', path: '/legal/privacy' },
  { label: 'Contact', path: '/contact' },
  { label: 'Refund policy', path: '/legal/refund' },
  { label: 'Terms of service', path: '/legal/terms' },
  { label: 'Shipping policy', path: '/legal/shipping' },
];

const SiteFooter = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-[#27272A] bg-[#09090B]" data-testid="site-footer">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#A1A1AA]">
          <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
            <span>© {year}, Kehele Keff Music</span>
            <span className="text-[#3f3f46]">·</span>
            {FOOTER_LINKS.map((link, idx) => (
              <React.Fragment key={link.path}>
                <Link to={link.path} className="hover:text-white transition-colors" data-testid={`footer-link-${idx}`}>
                  {link.label}
                </Link>
                {idx < FOOTER_LINKS.length - 1 && <span className="text-[#3f3f46]">·</span>}
              </React.Fragment>
            ))}
          </div>
          <SocialLinksRow compact align="start" />
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
